import Model from '@/lib/data/Model';
import FormData from './VisitFormData';
import FormSection from './FormSection';
import FormQuestion from './FormQuestion';

class VisitForm extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'name',
        'survey_info_id',
        {
            name: 'questions',
            association: {
                type: 'many',
                model: FormQuestion,
            },
        },
        {
            name: 'sections',
            association: {
                type: 'many',
                model: FormSection,
            },
        },
        {
            name: 'data',
            association: {
                type: 'one',
                model: FormData,
            },
        },
        'is_used_for_score',
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [];
}

export default VisitForm;
